import { useCallback, useState, useMemo } from "react"

const useWorkerProcess = ({
  file}) => {

  const [progress, setProgress] = useState(undefined);
  const [result, setResult] = useState(undefined);
  const worker = useMemo(() => new Worker(file),[file]);

  const execute = useCallback((infoToProcess) => {
    try {
      worker.onmessage = ({data = {}}) => {
        const {progress , result} = data;
        if (progress) {
          setProgress(progress);
        }
        if (result) {
          setResult(result);
        }
      }

      worker.postMessage(infoToProcess);
    } catch (e) {
      setResult({error:e});
    }
  },[worker]);

  const kill = useCallback(() => {
    worker.terminate()
  },[worker]);

  const messageToWorker = useCallback((message) => {
    worker.postMessage(message);
  },[worker]);

  const reRun = useCallback((data) => {
    setResult(undefined);
    execute(data);

  },[execute])

  return {
    kill,
    execute,
    reRun,
    messageToWorker,
    progress,
    result
  }
}

export default useWorkerProcess;